import React, { useCallback } from "react";
import useMapConfig, {
  WitnessesVisualizationKey,
  WitnessesVisualizationVariant
} from "../../../utils/useMapConfig";

interface Props {
  witnessesVisualizationKey: WitnessesVisualizationKey;
  visualisationVariant?: WitnessesVisualizationVariant;
}

const VisualizationToggle: React.FC<Props> = ({
  witnessesVisualizationKey,
  visualisationVariant
}) => {
  const isActive = useMapConfig(
    useCallback(
      (state) => {
        let active =
          witnessesVisualizationKey === state.witnessesVisualizationKey;

        if (
          visualisationVariant &&
          state.witnessesVisualizationVariant !== visualisationVariant
        ) {
          active = false;
        }

        return active;
      },
      [witnessesVisualizationKey, visualisationVariant]
    )
  );
  const setWitnessesVisualizationKey = useMapConfig(
    (state) => state.setWitnessesVisualizationKey
  );
  const setWitnessesVisualizationVariant = useMapConfig(
    (state) => state.setWitnessesVisualizationVariant
  );

  const toggle = useCallback(() => {
    setWitnessesVisualizationKey(
      isActive ? WitnessesVisualizationKey.none : witnessesVisualizationKey
    );

    if (!isActive && visualisationVariant) {
      setWitnessesVisualizationVariant(visualisationVariant);
    }
  }, [
    isActive,
    setWitnessesVisualizationKey,
    setWitnessesVisualizationVariant,
    visualisationVariant,
    witnessesVisualizationKey
  ]);

  return (
    <button
      type="button"
      className={`ml-2 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none ${
        isActive
          ? "bg-hotspotty-400 dark:bg-gray-100 dark:hover:bg-gray-200"
          : "bg-gray-200 dark:bg-gray-500 dark:hover:bg-gray-400"
      }`}
      aria-pressed="false"
      aria-labelledby="show-witnessing-visualizations-label"
      onClick={toggle}
    >
      <span
        aria-hidden="true"
        className={`pointer-events-none inline-block h-5 w-5 rounded-full bg-white dark:bg-gray-800 shadow transform ring-0 transition ease-in-out duration-200 ${
          isActive ? "translate-x-5" : "translate-x-0"
        }`}
      />
    </button>
  );
};

export default VisualizationToggle;
